
import { Options, Vue } from "vue-class-component";
import { mapGetters } from 'vuex'
import QuestionDetail from "../../components/QuestionDetail.vue"
import { getCollectionDetailByIds } from "@/api/index";
import { getCurrentInstance } from "vue";

@Options({
  components: { QuestionDetail },
  computed: {
    ...mapGetters(['questionIds', 'questionData'])
  }
})
export default class CollectionDetails extends Vue {
  $store
  currentQuestionId: any = ''
  currentQuestion: any = null
  currentIndex: number = 0
  leftQuestionIds: string[] = []
  loading: boolean = false
  finished: boolean = false
  questionDatas: any[] = []
  $xesLog = getCurrentInstance()?.appContext.config.globalProperties.$xesLog
  reportDataMap = {
    'page_name': 'que_ans',
    'biz_name': 'int_lear'
  }
  created() {
    this.currentQuestionId = localStorage.getItem('current_id')
    this.questionDatas = (this as any).questionData;
  }
  mounted() {
    this.detailQuestionData()
    // pv
    this.$xesLog.view('que_ans_pv', {
      ...this.reportDataMap,
      event_type: 'pv',
      source_location: 'false_notebook',
      event_name: '错题解析-页面PV'
    })
  }
  // 从列表中找到当前id对应的数据
  detailQuestionData() {
    let questionData = this.questionDatas;
    let questionIds = (this as any).questionIds
    questionData.forEach((item, index) => {
      if(item.nry_question_id === this.currentQuestionId) {
        this.currentQuestion = item
        this.currentIndex = index
      }
    })
    questionIds.forEach((qid, index) => {
      if (index >= questionData.length) {
        this.leftQuestionIds.push(qid)
      }
    })
  }
  reportAction(actionDesc) {
    // 点击埋点
    this.$xesLog.track('que_ans_click', {
      ...this.reportDataMap,
      event_type: 'click',
      exer_status: actionDesc,
      event_name: '错题解析-功能点击'
    })
  }
  // 上一题
  prevQuestion() {
    if (this.currentIndex === 0){
      return
    }
    this.currentIndex --
    this.currentQuestion = this.questionDatas[this.currentIndex]
    this.currentQuestionId = this.currentQuestion.nry_question_id
    localStorage.setItem('current_id', this.currentQuestionId)
    // 点击埋点
    this.$xesLog.view('que_ans_click', {
      ...this.reportDataMap,
      event_type: 'click',
      check_more: 'pre_exer',
      event_name: '错题解析-功能点击'
    })
  }
  // 下一题
  nextQuestion() {
    let questionData = this.questionDatas;
    let questionIds = (this as any).questionIds
    if (this.currentIndex >= questionIds.length - 1){
      return
    }
    if (this.currentIndex === questionData.length - 1) {
      this.getCollectionDetailByIds()
      return
    } 
    this.currentIndex ++
    this.currentQuestion = questionData[this.currentIndex]
    this.currentQuestionId = this.currentQuestion.nry_question_id
    localStorage.setItem('current_id', this.currentQuestionId)
    // 点击埋点
    this.$xesLog.view('que_ans_click', {
      ...this.reportDataMap,
      event_type: 'click',
      check_more: 'next_exer',
      event_name: '错题解析-功能点击'
    })
  }
  // 根据题目ids获取题目详情列表
  getCollectionDetailByIds() {
    if (this.loading) {
      return
    }
    if (this.leftQuestionIds.length > 0) {
      let nry_question_ids = this.leftQuestionIds.splice(0, 10)
      let data = {
        nry_question_ids,
        action_source: 'wrong_question'
      }
      this.loading = true
      getCollectionDetailByIds(data).then((res) => {
        this.loading = false
        if (res.data.code !== 0) {
          this.leftQuestionIds = nry_question_ids.concat(this.leftQuestionIds)
          this.$dialog.alert({
            message: res.data.message,
            confirmButtonText: '我知道了'
          })
          return
        }
        this.questionDatas = this.questionDatas.concat(res.data.data.list);
        // console.log(this.questionDatas, res.data.data.list)
        this.$store.commit('SET_QUESTION_DATA', this.questionDatas);
        if (nry_question_ids.length < 10) {
          this.finished = true
        }
        this.nextQuestion()
      }).catch((err) => {
        this.loading = false
        console.log('加载列表详情失败：', err)
        this.leftQuestionIds = nry_question_ids.concat(this.leftQuestionIds)
      })
    }
  }
}
